import { useState } from "react";
import { routePath } from "config/routeMgt/routePath";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import homeIcon from "assets/icons/dashboard.png";
import priceIcon from "assets/icons/pricing.png";
import jobsIcon from "assets/icons/jobs.png";
import chatIcon from "assets/icons/chat.png";
import talentsIcon from "assets/icons/talents.png";
import settingsIcon from "assets/icons/settings.png";
import { useGetRecruiterCount } from "features/home/hooks/useGetRecruiterCount";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { Modal, Progress } from "antd";
import { SupportChat } from "features/support/pages/SupportChat";
import { MessageOutlined } from "@ant-design/icons";
import { AppButton } from "components/button/AppButton";
import avatar from "assets/images/default.webp";
import { useCheckPermission } from "./hooks/useHasPermission";
import { useGetUnreadMessageCount } from "features/message/hooks/useGetUnreadMessageCount";


export const CorporateRecruiter = () => {
  const location = useLocation();
  const { data } = useGetRecruiterCount();
  const { userInfo } = useGetUserInfo();
  const [isChatOpen, setIsChatOpen] = useState(false);
  const canAccessSmartScreen = useCheckPermission('smartscreen.access');
  const { data: unreadMessageCount = 0 } = useGetUnreadMessageCount();
  const [openMenu, setOpenMenu] = useState(location.pathname.includes("smart"));

  const navigate = useNavigate();


  return (
    <div className="flex flex-col justify-between">
      <div className="mt-5 flex flex-col gap-y-3 justify-center px-5">
        <NavLink to={routePath.home} className="sidebarLink">
          <img src={homeIcon} alt="Home Icon" className="h-6" />
          <span className="text-sm">Dashboard</span>
        </NavLink>
        <NavLink to={routePath.enterpriseDashboard} className="sidebarLink">
          <i className="ri-shield-user-line text-xl"></i>
          <span className="text-sm ">Enterprise Dashboard</span>
        </NavLink>
        <NavLink to={routePath.team} className="sidebarLink">
          <i className="ri-shield-user-line text-xl"></i>
          <span className="text-sm ">Team</span>
        </NavLink>
        <NavLink to={routePath.jobs} className="sidebarLink">
          <img src={jobsIcon} alt="Job Icon" className="h-6" />
          <span className="text-sm ">Jobs</span>
        </NavLink>

        <NavLink to={routePath.talents} className="sidebarLink">
          <img src={talentsIcon} alt="folder Icon" className="h-6" />
          <span className="text-sm">Talents</span>
        </NavLink>
        <NavLink to={routePath.folders} className="sidebarLink">
          <i className="ri-folder-2-line text-xl"></i>
          <span className="text-sm">Folders</span>
        </NavLink>
        <NavLink to={routePath.pricing} className="sidebarLink">
          <img src={priceIcon} alt="pricing Icon" className="h-6" />
          <span className="text-sm">Pricing</span>
        </NavLink>
        <NavLink to={routePath.settings} className="sidebarLink">
          <img src={settingsIcon} alt="settings Icon" className="h-6" />
          <span className="text-sm">Settings</span>
        </NavLink>

        <NavLink to={routePath.messages} className="sidebarLink relative">
          <img src={jobsIcon} alt="message Icon" className="h-6" />
          <span className="text-sm flex items-center gap-6">
            Messages
            {unreadMessageCount > 0 && (
              <span className="bg-red-500 text-white text-xs font-bold rounded-full px-1.5 py-0.5 min-w-[18px] h-[18px] flex items-center justify-center">
                {unreadMessageCount > 99 ? "99+" : unreadMessageCount}
              </span>
            )}
          </span>
        </NavLink>
        {canAccessSmartScreen && (
          <div
            className="sidebarLink flex items-center cursor-pointer"
            onClick={() => setOpenMenu(!openMenu)}
          >
            <img src={chatIcon} alt="chat Icon" className="h-6" />
            <span className="text-sm flex-1">CV SmartScreen</span>

            <i
              className={`ri-arrow-down-s-line transition-transform ${
                openMenu ? "rotate-180" : ""
              }`}
            ></i>
          </div>
        )}
        {openMenu && (
          <div className="ml-8 mt-2 space-y-2">
            <NavLink to={routePath.cvchat} className="sidebarLink">
              <span className="text-sm">New Upload</span>
            </NavLink>
            <NavLink to={routePath.cvchatHistory} className="sidebarLink">
              <span className="text-sm">Upload History</span>
            </NavLink>
          </div>
        )}
      </div>

      {/* <div
        className="fixed bottom-6 right-6 w-14 h-14 bg-primary rounded-full flex items-center justify-center shadow-lg cursor-pointer z-50"
        onClick={() => setIsChatOpen(true)}
      >
        <MessageOutlined className="text-white text-xl" />
      </div> */}

      {isChatOpen && (
        <SupportChat isOpen={isChatOpen} setIsOpen={setIsChatOpen} />
      )}

      {data?.profile.total != 100 && (
        <div className="mx-2">
          <div className="bg-white mx-auto px-2 py-4 rounded-lg">
            <img
              src={userInfo?.photo != null ? userInfo?.photo : avatar}
              alt="avatar"
              className="h-12 w-12 rounded-full mb-2"
            />
            <div className="flex flex-row items-center">
              <h1 className="text-xs font-bold mb-4">Complete your Profile!</h1>
              <Progress
                type="circle"
                strokeColor={
                  data?.profile.total === 100
                    ? "#65DE02"
                    : data?.profile.total >= 90
                      ? "#3CB371"
                      : data?.profile.total >= 80
                        ? "#FFBF00"
                        : data?.profile.total >= 70
                          ? "#FF8C00"
                          : data?.profile.total >= 60
                            ? "#FF6347"
                            : "#FF0000"
                }
                percent={data?.profile.total}
                strokeWidth={10}
                size={55}
                format={() => null}
              />
            </div>

            <p className="text-gray-700 mb-8 text-xs">
              Complete your profile to finish setting up your account.
            </p>
            <AppButton
              type="button"
              label="Complete Now"
              handleClick={() => navigate("/settings")}
            />
          </div>
        </div>
      )}
    </div>
  );
};
